<template>
  <div class="div-home">
    <div>
      <swiper :options="swiperOption" ref="mySwiper" class="swiper-container">
        <swiper-slide class="swiper-slide"><img class="img-slide" src="static/img/banner.png" alt=""/></swiper-slide>
        <swiper-slide class="swiper-slide"><img class="img-slide" src="static/img/banner2.png" alt=""/></swiper-slide>
        <swiper-slide class="swiper-slide"><img class="img-slide" src="static/img/banner3.png" alt=""/></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="div-content">
      <div class="div-head">
        <label class="label-head-cn">
          公司简介
        </label>
        <br/>
        <label class="label-head-en">
          Company Profile
        </label>
      </div>
      <div class="div-description">
        <label class="label-description">
          &ensp;&ensp;&ensp;&ensp;深圳慧源创新科技有限公司注册成立于2016年，是一家专注无人机智能技术研发的高新技术企业。多年来，不断推动无人机在消费、行业(热成像侦査、巡检、 狩猎等) 的蓬勃发展。为客户提供具有创新和成本领先的TaiShan Solution一站式技术解决方案。
        </label>
      </div>
      <div >
        <el-row type="flex" :gutter="36" >
          <el-col :span="8" ><img  src="static/img/home01.png" alt=""/></el-col>
          <el-col :span="8" ><img  src="static/img/home02.png" alt=""/></el-col>
          <el-col :span="8" ><img  src="static/img/home03.png" alt=""/></el-col>
<!--          <el-col :span="6" ><img  src="static/img/images01.png" alt=""/></el-col>
          <el-col :span="6" ><img  src="static/img/images02.png" alt=""/></el-col>
          <el-col :span="6" ><img src="static/img/images03.png" alt=""/></el-col>
          <el-col :span="6" ><img  src="static/img/images04.png" alt=""/></el-col>-->
        </el-row>
      </div>
    </div>
    <div class="div-content">
      <div class="div-head">
        <label class="label-head-cn">
          企业动态
        </label>
        <br/>
        <label class="label-head-en">
          Business Dynamics
        </label>
      </div>
      <div class="div-description2">
        <el-row type="flex" justify="center">
          <el-col :span="12" >
            <div class="div-description2-content">
                <label class="label-description2-content">2020年迎新年会<span class="span-description2-content">2020/01/01</span></label>
            </div>
            <div class="div-description2-content">
              <label class="label-description2-content">2020年慧源创新年度篮球赛<span class="span-description2-content">2020/05/04</span></label>
            </div>
            <div class="div-description2-content">
              <label class="label-description2-content">2020年圣诞迎新<span class="span-description2-content">2020/12/24</span></label>
            </div>
            <div class="div-description2-content">
              <label class="label-description2-content">2021年迎新年会<span class="span-description2-content">2021/01/01</span></label>
            </div>
            <div class="div-description2-content">
              <label class="label-description2-content">2021年元宵节<span class="span-description2-content">2021/02/26</span></label>
            </div>
            <div class="div-description2-content">
              <label class="label-description2-content">2021年妇女节<span class="span-description2-content">2021/03/08</span></label>
            </div>
          </el-col>
          <el-col :span="12" >
            <div class="div-description-img">
              <img class="col-img" src="static/img/images05.png" alt=""/>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="div-description3" >
      <div class="div-content" >
        <div class="div-head">
          <label class="label-head-cn">
            服务宗旨
          </label>
          <br/>
          <label class="label-head-en">
            Purpose of service
          </label>
        </div>
        <div class="div-card-parent">
          <el-row type="flex" :gutter="100">
            <el-col :span="8" class="el-card1">
              <el-card class="div-card">
                <img src="static/img/icon05.png" alt=""/>
                <br/>
                <label class="p-card">助力客户，成就非凡</label>
              </el-card>
            </el-col>
            <el-col :span="8" class="el-card2">
              <el-card class="div-card">
                <img src="static/img/icon06.png" alt=""/>
                <br/>
                <label class="p-card">以服务为基础，以质量为生存，以科技求发展</label>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="div-card ">
                <img src="static/img/icon07.png" alt=""/>
                <br/>
                <label class="p-card">以人才和技术为基础，创造最佳的产品和服务</label>
              </el-card>
            </el-col>
          </el-row>
          <div class="div-empty">
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'Home',
  data () {
    return {
      swiperOption: {
        loop: true,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        autoplay: true,
        speed: 400,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  deactivated () {
    // console.log('---deactivated')
    if (this.$refs.mySwiper && !this.$refs.mySwiper.swiper.autoplay.paused) {
      // console.log('---deactivated paused')
      this.swiper.autoplay.pause()
    }
  },
  activated () {
    // console.log('activated')
    if (this.$refs.mySwiper && this.$refs.mySwiper.swiper.autoplay.paused) {
      // console.log('---activated autoplay')
      this.swiper.autoplay.run()
    }
  },
  mounted () {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log('mounted')
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div-home{
  overflow: hidden;
  -ms-overflow-x: hidden;
  -ms-overflow-y: hidden;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
  border: 0;
  padding: 0;
  margin: 0;
}
.div-home::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.swiper-container{
  position: relative;
  width: 90%;
  min-width: 1440px;
  height: 720px;
}
.swiper-slide{
  width: 90%;
  min-width: 1440px;
  text-align: center;
}
.img-slide{
  text-align: center;
  opacity: 1
}
.div-head{
  padding-top: 60px;
  text-align: center;
}
.label-head-cn{
  font-size: 26px;
  color: black;
}
.label-head-en{
  font-size: 26px;
  color: #FFB400;
}
.div-content{
  width: 60%;
  min-width: 1060px;
  position: relative;
  left: 20%;
  text-align: left;
}
.div-description{
  margin-top: 20px;
  margin-bottom: 30px;
}
.div-description2{
  margin-top: 30px;
  margin-bottom:60px;
  border: 2px solid #B1B1B1;
  padding-top: 20px;
  padding-bottom: 20px;
}
.div-description2-content{
  border-bottom: 1px dashed #1A1A1A;
  margin-bottom: 20px;
  margin-left: 10px;
  padding: 6px;
}
.label-description2-content{
  font-size: 18px;
}
.span-description2-content{
  float: right;color: #B1B1B1;
  font-size: 14px
}
.label-description{
  font-size: 20px;
}
.div-description-img{
  text-align: right;
  vertical-align: middle;
  margin-right: 20px;
}
.col-img{
  padding-top: 5px;
  max-width:481px;
  max-height:320px;
  width: auto;
  height: auto;
}
.div-description3{
  background: #F4F4F4;
}
.div-card-parent{
  margin-top: 20px;
}
.div-card{
  width: 300px;
  height: 200px;
  padding-left: 14px;
  padding-right: 14px;
  text-align: center;
  display:table-cell;
  vertical-align:middle;
  border-radius:40px;
  margin-top: 20px;
}
.p-card{
  color: #808080;
  font-size: 16px;
}

.div-empty{
  padding: 80px;

}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue